import React  from 'react';
import { AppContext } from '../AppContext';
import { useLocation, Outlet } from 'react-router-dom';

import YesNoDialog from './YesNoDialog';
import Notifications from './Notifications';

const Root = (props) => {
    const app = React.useContext(AppContext);
    const notificationsRef = React.useRef();
    const [showYesNoDialog, setShowYesNoDialog] = React.useState(false);
    const [dialogModel, setDialogModel] = React.useState({});

    const audioRef1 = React.useRef(null);

    React.useEffect(() => {
        app.onNotification = (model) => {
            notificationsRef.current.createToast(model);
            audioRef1.current.play();
        };
        app.onPopUp = (model, template) => {
            console.log(model, template);
            if (template === "YesNoDialog") setShowYesNoDialog(true);
            setDialogModel(model);
        };
        return () => {
            app.onNotification = null;
            app.onPopUp = null;
        };
    }, []);



    return (
        <>
            <Notifications ref={notificationsRef} timeToClose={4000} />
            <YesNoDialog show={showYesNoDialog} model={dialogModel} onClosePopup={() => setShowYesNoDialog(false)} />
            <Outlet />
            <audio ref={audioRef1} src="assets/Audio/chime.mp3" />
        </>
    )
};

export default Root;

